import React, { useEffect, useState } from "react";
import { Target, ChevronDown } from "lucide-react";
import api, { formatMoney, formatNumber } from "../lib/api";

const MEDAL = ["bg-amber-400 text-white", "bg-slate-400 text-white", "bg-orange-700 text-white"];

function Stat({ label, value, testid }) {
  return (
    <div className="rounded-lg bg-slate-50 p-3">
      <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">{label}</div>
      <div className="font-display text-xl font-extrabold" data-testid={testid}>{value}</div>
    </div>
  );
}

export const SeguimientoListaD = ({ importId }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!importId) return;
    api.get("/informes/seguimiento-lista-d", { params: { import_id: importId } }).then((r) => setData(r.data)).catch(() => setData(null));
  }, [importId]);
  const s = data?.seguimiento;
  if (!s || !s.n_lista) return null;
  return (
    <div className="card p-4 sm:p-6 mb-6" data-testid="seguimiento-lista-d">
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between gap-3 text-left" data-testid="seguimiento-lista-d-toggle">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold flex items-center gap-1"><Target size={12} /> Seguimiento · ventas de {data.label}</div>
          <h3 className="font-display text-xl font-bold">¿Se vendió la lista D real de {s.mes_lista}?</h3>
          <p className="text-xs text-slate-500 mt-1">
            {s.vendidos} de {s.n_lista} productos vendidos · {formatMoney(s.liberado)} de stock parado liberado a coste. La lista se recalcula con el filtro guardado.
          </p>
        </div>
        <ChevronDown size={18} className={`text-slate-400 shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-4">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-5">
            <Stat label="Productos vendidos" value={`${s.vendidos} / ${s.n_lista}`} testid="seg-vendidos" />
            <Stat label="Unidades" value={formatNumber(s.uds)} testid="seg-uds" />
            <Stat label="Facturado" value={formatMoney(s.facturacion)} testid="seg-facturacion" />
            <Stat label="Stock liberado (coste)" value={formatMoney(s.liberado)} testid="seg-liberado" />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div>
              <h4 className="text-xs uppercase tracking-widest font-bold text-slate-400 mb-2">Quién los vendió</h4>
              {s.ranking.length === 0 ? <p className="text-sm text-slate-500">Nadie vendió productos de la lista.</p> : (
                <ol className="space-y-1.5">
                  {s.ranking.map((e, i) => (
                    <li key={e.vendedor} className="flex items-center gap-3 rounded-lg border border-slate-200 px-3 py-2" data-testid={`seg-ranking-${i}`}>
                      <span className={`h-6 w-6 shrink-0 rounded-full text-[11px] font-bold flex items-center justify-center ${MEDAL[i] || "bg-slate-100 text-slate-600"}`}>{i + 1}</span>
                      <span className="flex-1 text-sm font-semibold truncate">{e.nombre}</span>
                      <span className="text-xs text-slate-500">{e.productos} prod. · {e.uds} uds</span>
                      <span className="font-mono text-sm font-semibold w-20 text-right">{formatMoney(e.facturacion)}</span>
                    </li>
                  ))}
                </ol>
              )}
            </div>
            <div className="overflow-x-auto">
              <h4 className="text-xs uppercase tracking-widest font-bold text-slate-400 mb-2">Productos de la lista vendidos</h4>
              {s.productos.length > 0 && (
                <table className="dense" data-testid="seg-productos">
                  <thead><tr><th>Producto</th><th className="num">Uds</th><th className="num">€</th><th>Vendido por</th></tr></thead>
                  <tbody>
                    {s.productos.map((p) => (
                      <tr key={p.cn}>
                        <td className="text-xs font-semibold">{p.descripcion}</td>
                        <td className="num">{p.uds}</td>
                        <td className="num">{formatMoney(p.facturacion)}</td>
                        <td className="text-xs text-slate-500">{p.vendedores.join(", ")}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
